
import {stepToHour, stepFrom, stepFromCeil} from 'helpers/date'
import {mapAuto} from 'helpers/vuex-bind'

export default {
  filters: {
    unit(value, unit = '') {
      return value ? value + unit : ''
    },

    hour(value) {
      return value ? Number(value).toFixed(1) : ''
    },

    hourSum(value) {
      return Number(value).toFixed(1)
    },
  },

  data() {
    return {
      allSum: 0,
      colCapacities: [],
      colSums: [],
      rowSums: [],
      typeSums: [],

      colIdles: [],
      colIdleSum: 0,
    }
  },

  computed: {
    ...mapAuto(['timeStepMinutes']),
  },

  methods: {
    makeSums(cols, rows, items) {
      let allSum = 0
      const colCapacities = cols.map(() => null)
      const colSums = cols.map(() => 0)
      const rowSums = rows.map(() => 0)

      for(const item of items) {
        if(!item.hidden) {
          if(item.isRegister) {
            const capacity = this.store['re' + this.tasks[item.task].model.type] || 0
            for(let i = item.begin; i < item.end; ++i) {
              if(i in colCapacities) {
                colCapacities[i] += capacity
              }
              if(i in colSums) {
                ++colSums[i]
              }
            }
          }

          const hour = stepToHour(item.end - item.begin)
          rowSums[item.row] += hour
          allSum += hour
        }
      }

      this.allSum = allSum
      this.colCapacities = colCapacities
      this.colSums = colSums
      this.rowSums = rowSums

      // 遊んでいる枠を行ごとに集計する
      const idleMap = cols.map(() => ({}))
      for(const [y, person] of Object.entries(this.people)) {
        if(person.model.isTimeValid) {
          const beginStep = stepFrom(person.model.begin_time) - this.displayBeginStep
          const endStep = stepFromCeil(person.model.end_time) - this.displayBeginStep
          for(let x = beginStep; x < endStep; ++x) {
            if(x in idleMap) {
              idleMap[x][y] = 1
            }
          }
        }
      }

      for(const shift of this.shifts) {
        for(let x = shift.begin; x < shift.end; ++x) {
          if(x in idleMap) {
            delete idleMap[x][shift.person]
          }
        }
      }

      this.colIdles = Object.keys(cols).map(x => Object.keys(idleMap[x]).length)
      this.colIdleSum = this.colIdles.reduce((acc, val) => acc + val, 0)
    },

    makeTypeSums(tasks, shifts) {
      const typeSums = {}

      for(const shift of shifts) {
        const task = tasks[shift.task].model
        if(!task.hidden) {
          const code = Math.max(task.task_code, 99)
          const hour = stepToHour(shift.end - shift.begin)

          if(!(code in typeSums)) {
            typeSums[code] = {
              label: task.isRegister ? 'レジ' : task.name,
              sum: hour,
            }
          }
          else {
            typeSums[code].sum += hour
          }
        }
      }

      this.typeSums = Object.values(typeSums)
    },
  },
}
